

// export default EditCategory;import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../utils/index";
// import { useAuthHeaders } from "../../../../components/Token";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { Modal, Button, Form } from "react-bootstrap";
// import TextField from "@mui/material/TextField";
// import FormLabel from "@mui/material/FormLabel";
// import { useEffect,useState } from "react";
// function EditCategory({ show, handleClose }) {
//   const { _id } = useParams();
//   const [categoryname, setCategoryName] = useState("");
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getsinglecategory/${_id}`)
//       .then((response) => {
//         console.log(response.data.data);
//         setCategoryName(response.data.data.categoryname);
//       })
//       .catch((error) => {
//         console.error("Error fetching category:", error);
//       });
//   }, [_id]);

//   const handleSave = (e) => {
//     e.preventDefault();
//     const data = { categoryname };

//     axios
//       .put(`${API_BASE_URL}/updatecategory/${_id}`, data, {
//         headers,
//       })
//       .then((response) => {
//         console.log("response:", response);
//         Swal.fire({
//           icon: "success",
//           title: "Edit Category has been saved",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate("/category");
//       })
//       .catch((error) => {
//         console.error("Error updating category:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.error,
//         });
//       });
//   };

//   return (
//     <Modal show={show} onHide={handleClose} className="p-3 w-50 m-auto mt-5">
//       <Modal.Header closeButton>
//         <Modal.Title className="text-center">
//           <h5 className="text-center ms-5">Edit Category</h5>
//         </Modal.Title>
//       </Modal.Header>
//       <Form onSubmit={handleSave}>
//         <Modal.Body>
//           <Form.Group controlId="formCategoryName">
//             <div className="m-auto">
//               <FormLabel>Change Category Name:</FormLabel>
//               <TextField
//                 type="text"
//                 id="name"
//                 value={categoryname}
//                 onChange={(e) => setCategoryName(e.target.value)}
//                 fullWidth
//               />
//             </div>
//           </Form.Group>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => navigate("/category")}>
//             Cancel
//           </Button>
//           <Button type="submit" variant="warning">
//             Save
//           </Button>
//         </Modal.Footer>
//       </Form>
//     </Modal>
//   );
// }

// export default EditCategory;
// --------------------------------------------
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../../utils/index";
import { useAuthHeaders } from "../../../../components/Token";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Modal, Button, Form } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";

function EditCategory({ show, handleClose, categoryId }) {
  const [categoryname, setCategoryName] = useState("");
  const navigate = useNavigate();
  const headers = useAuthHeaders();

  useEffect(() => {
    if (categoryId) {
      axios
        .get(`${API_BASE_URL}/getsinglecategory/${categoryId}`)
        .then((response) => {
          setCategoryName(response.data.data.categoryname);
        })
        .catch((error) => {
          console.error("Error fetching category:", error);
        });
    }
  }, [categoryId]);

  const handleSave = (e) => {
    e.preventDefault();
    const data = { categoryname };

    axios
      .put(`${API_BASE_URL}/updatecategory/${categoryId}`, data, {
        headers,
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Edit Category has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose(); // Close the modal on successful save
        navigate("/category");
      })
      .catch((error) => {
        console.error("Error updating category:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.error,
        });
      });
  };

  return (
    <Modal show={show} onHide={handleClose} >
      <Modal.Header >
        <Modal.Title className=" m-auto">
          <h5 className="text-center fw-bold">Edit Category</h5>
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSave}>
        <Modal.Body>
          <Form.Group controlId="formCategoryName">
            <div className="m-auto">
              <FormLabel>Change Type Name:</FormLabel>
              <TextField
                type="text"
                id="name"
                value={categoryname}
                onChange={(e) => setCategoryName(e.target.value)}
                fullWidth
              />
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="warning">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default EditCategory;
